import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function ThumpUpIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 15 15">
      <path
        d="M12.437 4.94q.468 0 .819.351t.35.819v1.17a1.2 1.2 0 0 1-.087.438l-1.755 4.122a1.2 1.2 0 0 1-.438.497q-.308.204-.643.205H6.005q-.483 0-.826-.344a1.13 1.13 0 0 1-.343-.826v-5.95q0-.233.095-.445.094-.213.255-.373l3.172-3.158A.94.94 0 0 1 9.455 1.3q.277.147.402.41a.77.77 0 0 1 .051.54L9.25 4.94zm-9.94 7.602q-.483 0-.826-.344a1.13 1.13 0 0 1-.344-.826V6.11q0-.483.344-.826.343-.345.826-.344.482 0 .826.344t.343.826v5.262q0 .483-.343.826a1.13 1.13 0 0 1-.826.344"
        fill="currentColor"
      />
    </BaseIcon>
  )
}
